import { IValueVessel, TVesselMsiValue, TVesselRecentSalesItem } from '../valueTypes';
import RecentSales from '../components/RecentSales';
import DynamicTab from '../../../shared/components/tabs/DynamicTab';
import { ITabPage } from '../../../shared/components/tabs/ITabPage';
import VesselOverview from '../components/VesselOverview';

export interface IVesselMsiValueProps extends ITabPage<IValueVessel> {
	vesselMsiValue: TVesselMsiValue | null;
	vesselRecentSales: TVesselRecentSalesItem[] | [];
}

const VesselMsiValue: React.FC<IVesselMsiValueProps> = ({ ...props }) => {
	const tabs = [
		{
			id: 'overview',
			label: 'Overview',
			content: (
				<div className="flex flex-col w-full gap-4">
					<VesselOverview vesselMsiValue={props.vesselMsiValue} vessel={props.data} />
				</div>
			),
		},
		{
			id: 'recentSales',
			label: 'Recent Sales',
			content: <RecentSales vesselRecentSales={props.vesselRecentSales} />,
		},
	];

	return <DynamicTab items={tabs} giveSpace={props.giveSpace} tabColor="msi-midblue-color-500" isLocalMode={props.isLocalMode}/>;
};

export default VesselMsiValue;
